module.exports = __webpack_public_path__ + "static/bg-boca-raton-historical-society-a53b2cc6d3d1b65536ac043e4655c888.webp";